import React, {Component} from 'react';
import ChatConvo from './chat_convo';
import ChatUserResultsEditor from './chat_user_results_editor.js';
import Markdown from './markdown';
import ReactJson from 'react-json-view'
import Loading from './loading';
import request from '../request';

export default class ChatUserShow extends Component {
  constructor(props) {
    super(props);
    let tab = anchorFromUrl() || 'reports';
    this.state = {tab};
  }

  selectTab(e, tab) {
    e.preventDefault();
    this.setState({tab})
  }

  renderUserData() {
    let {chat_user_session} = this.props;
    return <ChatDataViewer chat_user_session={chat_user_session} />
  }


  renderConvo() {
    let {chat_user_session} = this.props;
    return (
      <div className="chat_user_session_convo_holder">
        <ChatUserConvo chat_user_session={chat_user_session} />
      </div>
    )
  }


  renderNoSearchFound() {
    let {chat_user_session} = this.props;
    let link = `/admin/chat_user_sessions/${chat_user_session.id}/results/initialize_report`;
    return (
      <div>
        <h2>Search Pending</h2>
      <a href={link}>Initialize empty search results report</a>
      </div>
    )
  }

  renderResultsEditor() {
    let {chat_user_session} = this.props;
    if (chat_user_session.search_pending) return this.renderNoSearchFound();

    return <ChatUserResultsEditor chat_user_session={chat_user_session} />
  }

  renderMessages() {
    let {chat_user_session} = this.props;
    return (
      <div className="chat_user_session_messages_holder">
        <h2>Messages</h2>
        {chat_user_session.messages.map(message => {
          let link = `/admin/chat_user_sessions/${chat_user_session.id}/messages/${message.id}`;
          let phone = message.phone ? <p><span className="fa-solid fa-phone"> </span>{message.phone}</p> : null;
          return (
            <div key={message.id} className="chat_user_session_single_message_holder">
              <div className="message_holder_header">
                <div>
                  <p><b>{message.subject}</b></p>
                  <p>{message.email}</p>
                  {phone}
                </div>
                <p>{moment(message.sent_at).format('lll')}</p>
              </div>
              <div className="message_holder_content">
                <Markdown text={message.body} />
                <p><a href={link}>Show</a></p>
              </div>
            </div>
          )})}
      </div>
    )
  }


  renderReports() {
    let {chat_user_session} = this.props;
    return <Reports chat_user_session={chat_user_session} />
  }

  renderContent() {
    let {tab} = this.state;
    if (tab === 'convo') {
      return this.renderConvo();
    } else if (tab === 'user_data') {
      return this.renderUserData();
    } else if (tab === 'results') {
      return this.renderResultsEditor();
    } else if (tab === 'reports') {
      return this.renderReports()
    } else {
      return this.renderMessages();
    }
  }


  renderTabs() {
    let {tab} = this.state;
    let tabs = [
      {id: 'reports', label: 'Reports'},
      {id: 'results', label: 'Report Editor'},
      {id: 'messages', label: 'Messages'},
      {id: 'convo', label: 'Convo'},
      {id: 'user_data', label: 'User Data'}
    ];

    return (
      <ul className="nav nav-tabs">
        {tabs.map(({id, label}) => {
          let className = tab === id ? 'active' : ''
          return <li key={id} role="presentation" className={className}><a href='#'  onClick={e => this.selectTab(e, id)}>{label}</a></li>
        })}
      </ul>
    )
  }

  render() {
    return (
      <div className="chat_user_session_container">
        {this.renderTabs()}
        {this.renderContent()}
      </div>
    );
  }
}

class Reports extends Component {
  constructor(props) {
    super(props);
    this.state = {reports: []};
  }


  componentDidMount() {
    this.fetchReports();
  }

  fetchReports() {
    this.setState({loading: true});
    let {chat_user_session} = this.props;
    let url = `/admin/chat_user_sessions/${chat_user_session.id}/reports`;
    request('GET', url).then(reports => {
      this.setState({reports, loading: false});
    });
  }

  deleteReport(report) {
    if (!confirm('Are you sure?')) return;
    let {chat_user_session} = this.props;
    let url = `/admin/chat_user_sessions/${chat_user_session.id}/reports/${report.id}`
    request('DELETE', url).then(resp => {
      let {reports} = this.state;
      let index = reports.findIndex(r => r.id = report.id);
      reports.splice(index, 1);
      this.setState({reports});
    });
  }

  sendResumeSessionEmail() {
    if (!confirm('Are you sure you want to send a link to chat user to resume their session?')) return;
    let {chat_user_session} = this.props;
    let url = `/admin/chat_user_sessions/${chat_user_session.id}/send_resume_session_link`;
    request('POST', url);
  }

  renderNoOpenQuestions() {
    let {chat_user_session} = this.props;
    let edit_chat_user_session_url = `/admin/chat_user_sessions/${chat_user_session.id}/edit`;
    return (
      <div className="open_questions_section">
        <h4>No open questions.</h4>
        <p><b><a href={edit_chat_user_session_url}>Add questions</a></b> to have them asked of of the user on their next session.</p>
      </div>
    )
  }

  renderOpenQuestions() {
    let {chat_user_session} = this.props;
    if (!chat_user_session.open_questions || chat_user_session.open_questions.length === 0) return this.renderNoOpenQuestions();

    return (
      <div className="open_questions_section">
        <h4>Open Questions</h4>
        <div className="open_questions_display">
          <Markdown text={chat_user_session.open_questions} />
        </div>
      </div>
    )
  }


  renderShareMessage(report) {
    if (!report.share_message) return null;

    return (
      <div className="well">
        <label>SHARE MESSAGE</label>
        <Markdown text={report.share_message} />
      </div>
    )
  }


  renderInternalNotes(report) {
    if (!report.internal_notes) return null;
    return (
      <div className="well">
        <label>INTERNAL NOTES</label>
        <Markdown text={report.internal_notes} />
      </div>
    )
  }
  renderNoReports() {
    return (
      <div>
        <h3>No reports shared yet</h3>
      </div>
    )
  }

  renderReports() {
    let {reports, loading} = this.state;
    if (loading || !reports) return <Loading />
    if (reports.length === 0) return this.renderNoReports();
    return (
      <div>
        <h4>Shared Reports</h4>
        <hr/>
        {reports.map(report => {
          let created_at = moment(report.created_at).format('LLL');
          return (
            <div key={report.id}>
              <button className="btn btn-link red pull-right" onClick={e => this.deleteReport(report)}>Delete</button>
              <h4>
                <b><a href={report.link} target="_blank">{report.version}</a></b>
              </h4>
              <p><span className="subtle">Shared {created_at} by {report.admin_name}</span></p>

              <div className="row">
                <div className="col-md-6">
                  {this.renderShareMessage(report)}
                </div>
                <div className="col-md-6">
                  {this.renderInternalNotes(report)}
                </div>
              </div>
              <hr/>
            </div>
          )

        })}
      </div>
    )
  }


  render() {
    let {chat_user_session} = this.props;
    return (
      <div>
        {this.renderOpenQuestions()}

        <div className="chat_user_session-update">
          <button className="btn btn-success" onClick={e => this.sendResumeSessionEmail()}>Request Updates from User</button>
          <p>Sends an email to the chat user with link to resume chat or use the link below</p>
          <pre>{chat_user_session.link_to_resume_session}</pre>
        </div>
        {this.renderReports()}
      </div>
    )
  }
}

class ChatUserConvo extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }


  componentDidMount() {
    this.fetchConvo();
  }

  fetchConvo() {
    let {chat_user_session} = this.props;
    this.setState({loading: true});
    let url = `/admin/chat_user_sessions/${chat_user_session.id}/convo`
    request('GET', url)
      .then(convo => {
        this.setState({convo, loading: false});
    }).catch(error => {
      this.setState({loading: false});
      console.log("Error getting convo data", error);
    });
  }

  render() {
    let {loading, convo} = this.state;
    if (loading) return <Loading />
    if (!convo) return null;
    return (
      <div id="chat">
        <ChatConvo convo={convo} />
      </div>
    )
  }
}


class ChatDataViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.fetchChatData();
  }

  fetchChatData() {
    let {chat_user_session} = this.props;
    this.setState({loading: true});
    let url = `/admin/chat_user_sessions/${chat_user_session.id}/chat_data`
    request('GET', url)
      .then(chat_data => {
        this.setState({chat_data, loading: false});
    }).catch(error => {
      this.setState({loading: false});
      console.log("Error getting chat_data", error);
    });

  }

  render() {
    let {chat_data, loading} = this.state;
    if (!chat_data || loading) return null;
    return <ReactJson src={chat_data} name="chat_data" sortKeys={true} displayDataTypes={false} displayObjectSize={false} />
  }
}
